export default "__VITE_ASSET__DMmErcJS__"